import { Avatar, AvatarFallback } from '../ui/avatar';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Send } from 'lucide-react';

export const PostComments = ({ comments, newComment, setNewComment, onSubmit, submitting }) => (
  <div className="px-4 pb-4 border-t border-border">
    {comments.length > 0 && (
      <div className="space-y-3 py-3">
        {comments.map((comment) => (
          <div key={comment.id} className="flex gap-2">
            <Avatar className="h-8 w-8">
              <AvatarFallback className="bg-primary/20 text-primary text-xs">
                {comment.user?.name?.charAt(0) || 'U'}
              </AvatarFallback>
            </Avatar>
            <div className="flex-1 bg-white/5 p-2 rounded">
              <span className="font-medium text-sm text-white">{comment.user?.name}</span>
              <p className="text-sm text-muted-foreground">{comment.content}</p>
            </div>
          </div>
        ))}
      </div>
    )}

    <div className="flex gap-2 pt-3">
      <Textarea
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
        placeholder="Write a comment..."
        className="bg-black border-border text-white min-h-[40px] resize-none"
        rows={1}
        data-testid="comment-input"
      />
      <Button
        onClick={onSubmit}
        disabled={!newComment.trim() || submitting}
        className="bg-primary text-black"
        data-testid="submit-comment-btn"
      >
        <Send className="h-4 w-4" />
      </Button>
    </div>
  </div>
);
